var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"stroke-current inline-block",class:_vm.size?`w-${_vm.size} h-${_vm.size}`:`w-6 h-6`,attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M19 13l-7 7-7-7m14-8l-7 7-7-7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }